/**
 * Public product path: prefer current slug; fall back to id only when slug missing.
 */
export function productPublicPath(
  slug?: string | null,
  id?: string | null,
): string | null {
  const s = typeof slug === "string" ? slug.trim() : "";
  if (s) return `/produkter/${s}`;
  const i = typeof id === "string" ? id.trim() : "";
  if (i) return `/produkter/${i}`;
  return null;
}
